// extracted by mini-css-extract-plugin
module.exports = {"burger":"SocialLinks-module--burger--28-Gb"};